module.exports = __webpack_public_path__ + "img/logo.fda65d75.png";